import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { StoreHomeComponent } from './components/store-home/store-home.component';
import { OrderTypeComponent } from './components/order-type/order-type.component';
import { TableOrderComponent } from './components/table-order/table-order.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { ComboComponent } from './components/combo/combo.component';
import { CurrentOrderComponent } from './components/current-order/current-order.component';
import { ItemAddedComponent } from './components/item-added/item-added.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { CanReturnGuard } from './guards/can-return.guard';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { OrderResumeComponent } from './components/order-resume/order-resume.component';
import { OrderSentComponent } from './components/order-sent/order-sent.component';
import { ComboItemComponent } from './components/combo-item/combo-item.component';
import { PickComboItemComponent } from './components/pick-combo-item/pick-combo-item.component';
import { AdressPickerComponent } from './components/adress-picker/adress-picker.component';
import { OrderBaseDataComponent } from './components/order-base-data/order-base-data.component';
import { CarDescriptionComponent } from './components/car-description/car-description.component';
import { PaycardComponent } from './components/paycard/paycard.component';
import { AddressSearchComponent } from './components/address-search/address-search.component';
import { ConfirmAddressComponent } from './components/confirm-address/confirm-address.component';
import { AddCardComponent } from './components/add-card/add-card.component';
import { LocationPickerComponent } from './components/location-picker/location-picker.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { MenuItensComponent } from './components/menu-itens/menu-itens.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { NotfoundComponent } from './components/notfound/notfound.component';

const routes: Routes = [
  { path: '' , component: HomeComponent },
  { path: 'notfound' , component: NotfoundComponent },
  { path: 'contactus' , component: ContactusComponent },
  { path: 'storehome/:appname' , component: StoreHomeComponent },
  { path: 'storehome/:appname/direct/:type/:uid' , component: RedirectComponent },
  { path: 'storehome/:appname/table/:tablenumber' , component: TableOrderComponent },
  { path: ':appname' , component: StoreHomeComponent },
  { path: ':appname/direct/:type/:uid' , component: RedirectComponent },
  { path: ':appname/addresssearch' , component: AddressSearchComponent },
  { path: ':appname/picklocation' , component: LocationPickerComponent },
  { path: ':appname/confirmaddress' , component: ConfirmAddressComponent, canDeactivate: [CanReturnGuard] },
  { path: ':appname/ordertype' , component: OrderTypeComponent },
  { path: ':appname/table/:tablenumber' , component: TableOrderComponent },
  { path: ':appname/paycard' , component: PaycardComponent },
  { path: ':appname/menuitens' , component: MenuItensComponent, canDeactivate: [CanReturnGuard] },
  { path: ':appname/menuitem/:menuitemuid' , component: MenuItemComponent, canDeactivate: [CanReturnGuard] },
  { path: ':appname/combo/:combouid' , component: ComboComponent, canDeactivate: [CanReturnGuard] },
  { path: ':appname/pickcomboitem/:itemgroupuid' , component: PickComboItemComponent},
  { path: ':appname/comboitem/:comboitemuid' , component: ComboItemComponent, canDeactivate: [CanReturnGuard] },
  { path: ':appname/currentorder' , component: CurrentOrderComponent },
  { path: ':appname/orderbasedata' , component: OrderBaseDataComponent },
  { path: ':appname/adresspicker' , component: AdressPickerComponent },
  { path: ':appname/cardescription' , component: CarDescriptionComponent, canDeactivate: [CanReturnGuard]},
  { path: ':appname/itemadded' , component: ItemAddedComponent },
  { path: ':appname/editprofile' , component: EditProfileComponent, canDeactivate: [CanReturnGuard] },
  { path: ':appname/myprofile' , component: MyProfileComponent },
  { path: ':appname/addcard' , component: AddCardComponent },
  { path: ':appname/orderresume' , component: OrderResumeComponent },
  { path: ':appname/ordersent' , component: OrderSentComponent },
  { path: '**' , redirectTo:'notfound'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
